import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanLoad, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from 'src/app/login/login.service';
import { SessionService } from 'src/app/shared/services/session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardParticipante implements CanActivate, CanLoad {
  private permissionAcess: boolean;
  private role;


  constructor(
    private loginService: LoginService,
    private sessionService: SessionService,
    private router: Router) {
      this.role = this.sessionService.role;
      this.loginService.sessionLoggedIn().subscribe(
        response => this.permissionAcess = response
      );
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    console.warn('Auth Participantes');
    return this.checkAccess();
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkAccess();
  }

  /*
    NOTE Verifica se o perfil é do tipo participante
  */
  checkAccess() {
    if (sessionStorage.getItem('role') === 'ROLE_PARTICIPANTE') {
      return true;
    }
    this.router.navigate(['/participante/login']);
    return false;
    
  }

}
